import { useContext, useEffect, useRef } from "react";
// @ts-ignore
import { BlipChat } from "blip-chat-widget";
import { Dialog, Box } from "@mui/material";
import { MainContext } from "./main/context/MainContextProvider";
import { CloseOutlined } from "@mui/icons-material";

export default function BlipChatWidget(props: {
  show: boolean;
  setShow: (show: boolean) => void;
}) {
  const { show } = props;
  const { isMobile } = useContext(MainContext);
  const onClose = () => {
    props.setShow(false);
  };

  return (
    <>
      <Dialog fullScreen={isMobile} onClose={onClose} open={show}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: { xs: "100%", md: "550px" },
            width: { xs: "100%", md: "450px" },
            overflow: "hidden",
            position: { xs: "relative", sm: "fixed" },
            bottom: { xs: undefined, md: 10 },
            right: { xs: undefined, md: 10 },
            borderRadius: 2,
          }}
        >
          <Blip onCloseClick={onClose} />
        </Box>
      </Dialog>
    </>
  );
}

function Blip(props: { onCloseClick: () => void }) {
  const { user } = useContext(MainContext);
  const divBlipChatRef = useRef<HTMLDivElement | null>(null);

  function initializeBlipChat(element: HTMLElement) {
    new BlipChat()
      .withAppKey(
        "YmVpcm91dGVyMTplZWRjNDhhOS1lZDY4LTQyNmQtYWE5Ny1mMTZiNTIyOTY4Yzk="
      )
      .withTarget(element.id)
      .withCustomCommonUrl("https://bei.chat.blip.ai/")
      .withAccount({
        fullName: user?.name ?? "",
        email: user?.email ?? "",
        phoneNumber: user?.phone ?? "",
      })
      .build();
  }

  useEffect(() => {
    const divEl = divBlipChatRef.current;
    if (!divEl) {
      console.warn("divEl is null");
      return;
    }
    initializeBlipChat(divEl);
    return () => {};
  }, []);

  return (
    <Box sx={{ height: "100%", position: "relative" }}>
      <CloseOutlined
        sx={{
          position: "absolute",
          right: "15px",
          top: "15px",
          cursor: "pointer",
          width: "25px",
          height: "25px",
        }}
        onClick={props.onCloseClick}
      />
      <div
        style={{ height: "100%" }}
        id="blip-chat-widget"
        ref={divBlipChatRef}
      ></div>
    </Box>
  );
}

export function BlipChatIcon(props: { style?: React.CSSProperties }) {
  const { style } = props;
  return (
    <img
      src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yMy4zNjM5IDlDMjAuMTc0NSA5IDE2Ljg3NCA5LjUxOTE5IDE0LjYxMTggMTAuODkxM0MxMC45NDAzIDEzLjE1MzUgOS44NjQ4NSAxNy41NjY3IDEwLjAxMzIgMjEuNjQ2MUMxMC4xMjQ1IDI1LjE2OTIgMTEuMDUxNiAyOC45NTE5IDEzLjU3MzQgMzEuNTQ3OEMxNS45NDY4IDM0LjAzMjUgMjAuODQyMSAzNS4xNDUxIDI0LjIxNjggMzUuMTQ1MUMyNC4zNjUyIDM1LjE0NTEgMjQuNTEzNSAzNS4yNTYzIDI0LjUxMzUgMzUuNDQxOFYzOS4wMDJDMjQuNTEzNSAzOS4zMzU3IDI0Ljc3MzEgMzkuNjMyNCAyNS4xNDQgMzkuNjMyNEMyNS4xODExIDM5LjYzMjQgMjUuMTgxMSAzOS42MzI0IDI1LjIxODEgMzkuNjMyNEMyNS4zNjY1IDM5LjYzMjQgMjUuNDc3NyAzOS41NTgyIDI1LjU1MTkgMzkuNDg0MUMyNy4yMjA3IDM4LjAzNzcgMjguOTI2NyAzNi41NTQzIDMwLjU1ODQgMzUuMDcwOUMzMi4xMTYgMzMuNjI0NiAzMy44OTYxIDMyLjE0MTIgMzUuMDgyOCAzMC4zOTgyQzM3LjY0MTcgMjYuNzI2NyAzOC4wNDk2IDIxLjU3MTkgMzcuMTk2NyAxNy4yN0MzNi4zODA4IDEzLjE1MzUgMzMuNDUxMSAxMC40NDYzIDI5LjM3MTcgOS41OTMzNkMyNy42Mjg3IDkuMjIyNTEgMjUuNTE0OCA5IDIzLjM2MzkgOVoiIGZpbGw9IndoaXRlIi8+DQo8L3N2Zz4NCg=="
      alt="Contato Inteligente"
      style={{ ...style, backgroundColor: "#EE7D00", borderRadius: 20 }}
    />
  );
}
